export default "__VITE_PUBLIC_ASSET__3e85100b__"